/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Answer_6Inputs */

const en_help_center__account_n_technical__answer_6 = /** @type {(inputs: Help_Center__Account_N_Technical__Answer_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We take security seriously! Your account password is encrypted before storage (never stored in plain text) and we use 256-bit SSL encryption for all data transmission.`)
};

/**
* | output |
* | --- |
* | "We take security seriously! Your account password is encrypted before storage (never stored in plain text) and we use 256-bit SSL encryption for all data tra..." |
*
* @param {Help_Center__Account_N_Technical__Answer_6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__answer_6 = /** @type {((inputs?: Help_Center__Account_N_Technical__Answer_6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Answer_6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__answer_6(inputs)
});